var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.106,
    height: 121.024,
    viewBox: "102.796 51.6084 84.106 121.024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.812 135.452C125.917 135.452 126.812 136.348 126.812 137.452V140.824C126.812 145.038 128.919 147.144 133.132 147.144H153.83C158.044 147.144 160.15 145.038 160.15 140.824V117.691C160.15 116.047 158.182 115.202 156.99 116.334C150.881 122.128 144.877 125.024 138.978 125.024H125.548C119.228 125.024 113.856 122.812 109.432 118.388C105.008 113.964 102.796 108.592 102.796 102.272V76.3604C102.796 70.0404 105.008 64.6684 109.432 60.2444C113.856 55.8204 119.228 53.6084 125.548 53.6084H160.15C166.47 53.6084 171.842 55.8204 176.266 60.2444C180.69 64.6684 182.902 70.0404 182.902 76.3604V145.88C182.902 152.2 180.69 157.572 176.266 161.996C171.842 166.42 166.47 168.632 160.15 168.632H126.812C120.492 168.632 115.12 166.42 110.696 161.996C106.272 157.572 104.06 152.2 104.06 145.88V137.452C104.06 136.348 104.956 135.452 106.06 135.452H124.812ZM159.179 99.221C159.782 98.8596 160.15 98.2085 160.15 97.506V81.4164C160.15 77.2031 158.044 75.0964 153.83 75.0964H131.868C127.655 75.0964 125.548 77.2031 125.548 81.4164V98.4804C125.548 102.694 127.655 104.8 131.868 104.8H141.19C146.984 104.8 152.25 103.378 156.99 100.534L159.179 99.221Z",
    fill: "#1B191A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.812 135.452C125.917 135.452 126.812 136.348 126.812 137.452V140.824C126.812 145.038 128.919 147.144 133.132 147.144H153.83C158.044 147.144 160.15 145.038 160.15 140.824V117.691C160.15 116.047 158.182 115.202 156.99 116.334C150.881 122.128 144.877 125.024 138.978 125.024H125.548C119.228 125.024 113.856 122.812 109.432 118.388C105.008 113.964 102.796 108.592 102.796 102.272V76.3604C102.796 70.0404 105.008 64.6684 109.432 60.2444C113.856 55.8204 119.228 53.6084 125.548 53.6084H160.15C166.47 53.6084 171.842 55.8204 176.266 60.2444C180.69 64.6684 182.902 70.0404 182.902 76.3604V145.88C182.902 152.2 180.69 157.572 176.266 161.996C171.842 166.42 166.47 168.632 160.15 168.632H126.812C120.492 168.632 115.12 166.42 110.696 161.996C106.272 157.572 104.06 152.2 104.06 145.88V137.452C104.06 136.348 104.956 135.452 106.06 135.452H124.812ZM159.179 99.221C159.782 98.8596 160.15 98.2085 160.15 97.506V81.4164C160.15 77.2031 158.044 75.0964 153.83 75.0964H131.868C127.655 75.0964 125.548 77.2031 125.548 81.4164V98.4804C125.548 102.694 127.655 104.8 131.868 104.8H141.19C146.984 104.8 152.25 103.378 156.99 100.534L159.179 99.221Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter19",
    x: 102.796,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 132.37,
    y1: 53.6084,
    x2: 132.37,
    y2: 168.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.73d6e04a7a9c43aad261d3f1f63189a1.svg";
export { ForwardRef as ReactComponent };